<template>
  <div class="deduction-order-table">
    <!-- readonly模式 -->
    <template v-if="isDetail">
      <!-- 支付频率 -->
      <div class="readonly-item" v-if="rentCategory !== CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI">
        <label class="readonly-label">支付频率：</label>
        <span>{{ getFrequencyText }}</span>
      </div>

      <!-- 支付限额 -->
      <div class="readonly-item">
        <label class="readonly-label">支付限额：</label>
        <span>{{ getLimitText }}</span>
      </div>

      <!-- 支付费项表格 - readonly模式 -->
      <div class="readonly-item">
        <el-table :data="getSelectedDeductionList" class="readonly-table">
          <el-table-column label="支付顺序" width="100">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column label="支付费项" prop="feeTypeName" />
          <el-table-column label="金额" prop="feeAmount" />
        </el-table>
      </div>
    </template>

    <!-- 编辑模式 -->
    <template v-else>
      <el-form
        ref="formRef"
        :model="formModel"
        :rules="formRules"
        label-width="160px"
        >
        <!-- 支付频率 -->
        <el-form-item
          label="支付频率"
          prop="type"
          v-if="rentCategory !== CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI"
        >
          <el-radio-group v-model="formModel.type">
            <el-radio
              v-for="item in useDictParseList(frequencyState)"
              :key="item.value"
              :label="item.value"
            >
              {{ item.label }}
            </el-radio>
          </el-radio-group>
          <el-form-item
            v-if="formModel.type === FREQUENCY_MAP.WEEK"
            prop="startDate"
            style="margin-bottom: 0;"
          >
            <el-select
              v-model="formModel.startDate"
              clearable
              placeholder="请选择周扣日期"
              class="startDate"
            >
              <el-option
                v-for="item in useDictParseList(startDateState)"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-form-item>

        <!-- 支付限额 -->
        <el-form-item label="支付限额" prop="periodLimitType">
          <el-radio-group
            v-model="formModel.periodLimitType"
            @change="changeLimitType"
          >
            <el-radio
              v-for="item in useDictParseList(periodLimitState)"
              :key="item.value"
              :label="item.value"
            >
              {{ item.label }}
            </el-radio>
          </el-radio-group>
          <el-form-item
            v-if="formModel.periodLimitType === PERIOD_LIMIT_MAP.LIMIT"
            prop="limitCount"
            style="margin-bottom: 0;"
          >
            <el-input
              style="width: 220px"
              v-model.trim="formModel.limitCount"
              placeholder="请输入支付限额"
              maxlength="20"
              @input="handleInput"
            />
          </el-form-item>
        </el-form-item>
        <div class="add-fee-item" v-if="rentCategory !== CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI">
          <i
            class="el-icon-circle-plus"
            :class="{ 'disabled-icon': getCustomFeeList.length === 0 }"
            style="margin-right: 2px"
          >
            <el-button
              type="text"
              @click="addFeeItem"
              :disabled="getAddItemDisabled">
              添加费项
            </el-button>
          </i>
        </div>
        <!-- 支付费项表格 -->
        <el-table
          ref="multipleTable"
          v-if="rentCategory !== CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI"
          :data="formModel.tableData"
          border
          row-key="id"
          :key="tableKey"
          class="deduction-list"
          max-height="400"
          @selection-change="handleSelectionChange"
          >
          <el-table-column
            type="selection"
            reserve-selection
            :selectable="() => true"
          />
          <el-table-column label="支付顺序" width="80">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="feeTypeName" label="支付费项" align="center" width="120">
            <template slot-scope="scope">
              <div v-if="scope.row.isAdd">
                  <el-form-item
                    label-width="auto"
                    :prop="`tableData.${scope.$index}.feeTypeName`"
                    :rules="[
                      { required: true, message: '请选择', trigger: 'change' }
                    ]"
                  >
                    <el-select
                      style="width: 110px;"
                      v-model="scope.row.feeTypeName"
                      placeholder="请选择"
                      @change="changeFeeTypeName(scope.row)"
                    >
                      <el-option
                        v-for="(item, index) in getCustomFeeList"
                        :key="`${item.feeType}-${index}`"
                        :label="item.feeTypeName"
                        :value="item.feeTypeName"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
              </div>
              <div v-else>{{ scope.row.feeTypeName }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="feeAmount" label="金额" align="center">
            <template slot-scope="scope">
              <el-form-item
                label-width="auto"
                class="amount-input"
                :prop="`tableData.${scope.$index}.feeAmount`"
                :rules="[
                { required: true, message: '请输入金额', trigger: 'change' },
                { validator: (rule, value, callback) =>
                  validateAmount(rule, value, callback, scope.row), trigger: 'change' }
              ]">
                <span v-if="scope.row.customFlag === CUSTOM_FLAG.NORMAL">{{ scope.row.feeAmount }}元</span>
                <el-input
                  v-else
                  :style="{
                    width: '150px',
                    marginTop: scope.row.customFlag === CUSTOM_FLAG.NORMAL ? '4px' : '0px'
                  }"
                  v-number:money="{
                    isHideErr: true,
                  }"
                  v-model="scope.row.feeAmount"
                  placeholder="请输入"
                >
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="140">
            <template slot-scope="{ $index, row }">
              <div class="action-buttons">
                <el-button
                  type="text"
                  :disabled="$index === 0"
                  @click="handleMoveUp(row.id)"
                  >
                  上移
                </el-button>
                <el-button
                  type="text"
                  :disabled="$index === formModel.tableData.length - 1"
                  @click="handleMoveDown(row.id)"
                  >
                  下移
                </el-button>
                <el-button
                  v-if="row.isAdd"
                  type="text"
                  @click="handleDelete(row.id)">
                  删除
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
    </template>
  </div>
</template>
<script setup>
import { getEnum } from '@/api/global'
import { CATEGORY_CODE_MAP } from '@/store/dict/rentPlanDict.js'
import { useDictParseList } from '@/utils/useUtils'
import { limitMoreZero } from '@/utils/validate'
import { computed, nextTick, onMounted, ref, set, watch } from 'vue'
import { FREQUENCY_MAP, frequencyState, PERIOD_LIMIT_MAP, periodLimitState, startDateState } from '../config/enum.js'


const props = defineProps({
  // 支付配置（包含支付频率、限额和费项列表）
  config: {
    type: Object,
    default: () => ({
      type: '',
      startDate: '',
      periodLimitType: '',
      limitCount: '',
      deductionList: [],
    }),
  },
  // 租赁类别（用于判断是否显示支付频率）
  rentCategory: {
    type: [String, Number],
    default: '',
  },
  // 是否为详情模式（只读）
  isDetail: {
    type: Boolean,
    default: false,
  },
})


const CUSTOM_FLAG = {
  CUSTOM: 1,
  NORMAL: 0,
}

const customFeeList = ref([])

const formModel = ref({
  type: '',
  startDate: '',
  periodLimitType: '',
  limitCount: '',
  tableData: [],
})

const multipleTable = ref(null)

const formRef = ref(null)

const isProgrammaticSelection = ref(false)

const tableKey = ref(0)

// 表单验证规则
const formRules = computed(() => {
  const rules = {
    periodLimitType: [
      { required: true, message: '请选择支付限额', trigger: 'change' },
    ],
  }

  // 只有在非司机合作模式下才需要验证支付频率
  if (props.rentCategory !== CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI) {
    rules.type = [
      { required: true, message: '请选择支付频率', trigger: 'change' },
    ]

    // 如果选择了周扣，需要验证周扣日期
    if (formModel.value.type === FREQUENCY_MAP.WEEK) {
      rules.startDate = [
        { required: true, message: '请选择周扣日期', trigger: 'change' },
      ]
    }
  }

  // 如果选择了限额，需要验证限额数值
  if (formModel.value.periodLimitType === PERIOD_LIMIT_MAP.LIMIT) {
    rules.limitCount = [
      { required: true, message: '请输入支付限额', trigger: 'blur' },
      { pattern: /^\d+(\.\d{1,2})?$/, message: '请输入正确的金额格式', trigger: 'blur' },
    ]
  }

  return rules
})

// 强制重新渲染的方法
const forceRerender = () => {
  tableKey.value += 1
}

const handleSelectionChange = (selections) => {
  if (!isProgrammaticSelection.value) {
    formModel.value.tableData.forEach((item) => {
      const isSelected = selections.some((selected) => selected.id === item.id)
      item.selected = isSelected ? 1 : 0
    })
  }
}

// 保存当前选中状态
const saveSelectionState = () => {
  const selectedRows = multipleTable.value?.selection || []
  return selectedRows.map((row) => row.id)
}

// 恢复选中状态
const restoreSelectionState = (selectedIds) => {
  if (!selectedIds.length) return

  nextTick(() => {
    isProgrammaticSelection.value = true

    // 清空当前选中
    multipleTable?.value?.clearSelection()

    // 根据保存的ID重新选中
    formModel.value.tableData.forEach((row) => {
      if (selectedIds.includes(row.id)) {
        multipleTable?.value?.toggleRowSelection(row, true)
      }
    })

    isProgrammaticSelection.value = false
  })
}

// 保存滚动位置
const saveScrollPosition = () => {
  const table = multipleTable.value
  if (table && table.bodyWrapper) {
    return table.bodyWrapper.scrollTop
  }
  return 0
}

// 恢复滚动位置
const restoreScrollPosition = (scrollTop) => {
  nextTick(() => {
    const table = multipleTable.value
    if (table && table.bodyWrapper) {
      table.bodyWrapper.scrollTop = scrollTop
    }
  })
}

// 上移
const handleMoveUp = (id) => {
  const index = formModel.value.tableData.findIndex((item) => item.id === id)
  if (index > 0) {
    const temp = formModel.value.tableData[index]
    set(formModel.value.tableData, index, formModel.value.tableData[index - 1])
    set(formModel.value.tableData, index - 1, temp)
  }
}

// 下移
const handleMoveDown = (id) => {
  const index = formModel.value.tableData.findIndex((item) => item.id === id)
  if (index < formModel.value.tableData.length - 1) {
    const item = formModel.value.tableData[index]
    set(formModel.value.tableData, index, formModel.value.tableData[index + 1])
    set(formModel.value.tableData, index + 1, item)
  }
}

// 删除
const handleDelete = (id) => {
  const index = formModel.value.tableData.findIndex((item) => item.id === id)
  // 保存选中状态（排除被删除的项）
  const selectedIds = saveSelectionState().filter((itemId) => itemId !== id)

  const scrollTop = saveScrollPosition()

  formModel.value.tableData.splice(index, 1)

  forceRerender()

  restoreScrollPosition(scrollTop)

  restoreSelectionState(selectedIds)
}

const addFeeItem = () => {
  const newItem = {
    id: generateId(),
    selected: 1,
    feeType: '',
    feeTypeName: '',
    isAdd: true,
    customFlag: 1,
  }

  formModel.value.tableData.push(newItem)

  // 等待DOM更新后滚动到最后一行
  nextTick(() => {
    const table = multipleTable.value
    if (table && table.bodyWrapper) {
      // 滚动到底部
      table.bodyWrapper.scrollTop = table.bodyWrapper.scrollHeight
    }

    // 自动选中新添加的项目
    isProgrammaticSelection.value = true
    table?.toggleRowSelection(newItem, true)
    isProgrammaticSelection.value = false
  })
}

const changeFeeTypeName = (row) => {
  const customItem = customFeeList.value.find((item) => item.feeTypeName === row.feeTypeName)
  row.feeType = customItem.feeType
  // 手动触发金额字段的验证
  nextTick(() => {
    const index = formModel.value.tableData.findIndex((item) => item === row)
    if (index !== -1) {
      formRef.value.validateField(`tableData.${index}.feeAmount`)
    }
  })
}

const getCustomFeeList = computed(() => {
  return customFeeList.value.filter((item) => {
    return !formModel.value.tableData.some((row) => row.feeType === item.feeType)
  })
})

const getCustomFeeListFromEnum = async () => {
  const { code, data } = await getEnum({
    type: 'withholdCustomFee',
  })
  if (code === 1) {
    customFeeList.value = data.map((item) => {
      return {
        feeTypeName: item.name,
        feeType: item.code,
        customFlag: 1,
      }
    })
  }
}


// 判断是否需要校验金额上限
const shouldValidateAmountLimit = (rowData) => {
  // 只有后置费项和已选择的项需要校验金额上限
  // customFlag: 0: 签约时选择的费项  1: 后置费项
  return rowData.customFlag === 1 && rowData?.selected === 1
}

const validateAmount = (_, value, callback, row) => {
  if (value === '') {
    callback(new Error('请输入金额'))
  } else if (shouldValidateAmountLimit(row) && value > 10000) {
    callback(new Error('金额不能大于10000'))
  } else {
    callback()
  }
}

const generateId = () => {
  return Date.now() + Math.random().toString(36).substr(2, 9)
}

const getAddItemDisabled = computed(() => {
  const addedList = formModel.value.tableData.filter((item) => item.isAdd)
  return getCustomFeeList.length === 0
  || addedList.length >= customFeeList.value.length
})

// 获取选中的支付费项列表（用于readonly模式展示）
const getSelectedDeductionList = computed(() => {
  return formModel.value.tableData
})

// 支付频率显示文本
const getFrequencyText = computed(() => {
  let freqencyText = frequencyState[formModel.value.type]
  if (formModel.value.type === FREQUENCY_MAP.WEEK) {
    freqencyText += `/${startDateState[formModel.value.startDate]}`
  }
  return freqencyText || '--'
})

// 支付限额显示文本
const getLimitText = computed(() => {
  return formModel.value.limitCount ?
    `${periodLimitState[PERIOD_LIMIT_MAP.LIMIT]}/${formModel.value.limitCount}元` :
    periodLimitState[PERIOD_LIMIT_MAP.NO_LIMIT]
})

// 数字输入处理
const handleInput = (value) => {
  limitMoreZero(value, (res) => {
    formModel.value.limitCount = res
  }, 7)
}

// 支付限额变更
const changeLimitType = () => {
  formModel.value.limitCount = null
}

onMounted(() => {
  getCustomFeeListFromEnum()
})

// 监听父组件传入的配置变化
watch(() => props.config, (val) => {
  // 更新支付频率和限额
  formModel.value.type = val.type || FREQUENCY_MAP.DAY
  formModel.value.startDate = val.startDate || ''
  formModel.value.periodLimitType = val.limitCount ? PERIOD_LIMIT_MAP.LIMIT : PERIOD_LIMIT_MAP.NO_LIMIT
  formModel.value.limitCount = val.limitCount || ''

  // 更新费项列表
  const val_deductionList = val.deductionList || []
  if (val_deductionList.length) {
    // 本地列表
    formModel.value.tableData = val_deductionList.map((valItem) => {
      return {
        ...valItem,
        id: generateId(),
        feeType: valItem.feeType,
        feeAmount: valItem.feeAmount,
        isAdd: valItem.customFlag === 1,
      }
    })

    nextTick(() => {
      isProgrammaticSelection.value = true

      // 先清空所有选中状态
      multipleTable.value?.clearSelection()

      // 批量选中需要的项目
      const selectedItems = formModel.value.tableData.filter((item) => item.selected === 1)
      selectedItems.forEach((item) => {
        multipleTable.value?.toggleRowSelection(item, true)
      })

      isProgrammaticSelection.value = false
    })
  }

  nextTick(() => {
    formRef.value?.clearValidate()
  })
}, {
  immediate: true,
})

// 获取完整的支付配置（包括频率和限额）- 已重命名为getData，保留向后兼容
const getData = () => {
  return new Promise((resolve, reject) => {
    // 如果是只读模式，直接返回传入的数据
    if (props.isDetail) {
      const selectedItems = formModel.value.tableData
      const feeTypeList = selectedItems.map((item) => item.feeType)
      resolve({
        feeTypeList,
        feeTypeAndAmountList: formModel.value.tableData,
        ...props.config,
      })
      return
    }

    // 编辑模式需要验证表单
    // 验证整个表单
    formRef.value.validate((valid) => {
      if (!valid) {
        reject(new Error('表单验证失败'))
        return
      }

      if (props.rentCategory === CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI) {
        resolve({
          feeTypeList: [],
          feeTypeAndAmountList: [],
          type: formModel.value.type,
          startDate: formModel.value.startDate,
          periodLimitType: formModel.value.periodLimitType,
          limitCount: formModel.value.limitCount,
        })
        return
      }

      const selectedItems = formModel.value.tableData
      const feeTypeList = selectedItems.map((item) => item.feeType)
      resolve({
        feeTypeList,
        feeTypeAndAmountList: formModel.value.tableData,
        type: formModel.value.type,
        startDate: formModel.value.startDate,
        periodLimitType: formModel.value.periodLimitType,
        limitCount: formModel.value.limitCount,
      })
    })
  })
}

defineExpose({
  getData,
})
</script>

<style lang="scss" scoped>
.deduction-order-table {
  width: 600px;
}
.add-fee-item {
  color: #2761F3;
  cursor: pointer;
  text-align: right;
  margin-bottom: 10px;
}

.disabled-icon {
  opacity: 0.5;
  cursor: not-allowed;
}

.amount-input ::v-deep .el-form-item__error {
  margin-left: 12px;
}

::v-deep .el-table .el-form-item--small.el-form-item {
  margin: 20px 0 0 0;
  height: 60px;
}

::v-deep .el-table__body .el-table__row .el-table__cell:last-child .cell .el-button, .el-table__body .el-table__row .el-table__cell:last-child .cell a {
  margin-right: 6px;
}

.startDate ::v-deep .el-input {
  width: 220px;
}

// readonly模式样式
.readonly-item {
  margin-bottom: 16px;

  .readonly-label {
    display: inline-block;
    width: 160px;
    font-weight: 500;
    color: #606266;
  }

  .readonly-table {
    margin-top: 8px;
  }
}
</style>
